import React, { useEffect,useState} from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Bread from '../component/Breadcrumbs';
import Sidebar from '../component/Sidebar';
import Datatable from '../component/Datatable';
import {UserList} from '../Services/User';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialIcons from '../component/MaterialIcons';
import {blockUser} from '../Services/User';
import {AuthData} from '../Services/Authdata';
import TBOHotelDetail from './TBOHotelDetail';
import HotelBedsDetails from './HotelBedsDetails';
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


const HotelBooking = () =>  {
  const br = [{
    'title':'Flight',
    'icon':"",
    'url':'/flight'
  }];
  const calc = (num) => {
    num = num.toString(); //If it's not already a String
    num = num.slice(0, (num.indexOf("."))+3); //With 3 exposing the hundredths place
    return Number(num); //If you need it back as a Number

  }
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [srow, setSrow] = useState([]);
  const [open, setOpen] = React.useState(false);
  useEffect(() =>{
    UserList('admin/booking/hotels','GET',AuthData().token).then((result)=>{
      setData(result.data);
      //console.log(result.data);
    })
  },[])


  const refund = (data) => {
    Swal.fire({
      title: 'Please enter refund Amount',
      input: 'number',
      inputAttributes: {
        autocapitalize: 'off',
        step:"0.01",
      },
      showCancelButton: true,
      confirmButtonText: 'Refund',
      showLoaderOnConfirm: true,
      preConfirm: (amount) => {
        if(data.provider == 2 && amount > 0 && amount <= parseInt((data.amount.split(" "))[0])){

          let url = `Stripe/invoiceRefund/${data.booking_id}/${amount}`;
          return blockUser('GET',url,AuthData().token)
          .then(response => {
            Swal.fire(response.message);
          })
          .catch(error => {
            Swal.showValidationMessage(
              `Request failed: ${error.message}`
            )
          })

        }else if(data.provider == 1 && amount > 0 && amount <= parseInt((data.pymnt.amount) / 100)){
          let url = `Stripe/invoiceRefund/${data.booking_id}/${amount}`;
          return blockUser('GET',url,AuthData().token)
          .then(response => {
            Swal.fire(response.message);
            window.location.reload();
          })
          .catch(error => {
            console.log(error)
            Swal.showValidationMessage(
              `Request failed: ${error.message}`
            )
          })
        }
        else{
          Swal.showValidationMessage(
            `Invalid Amount ${amount}`
          )
        }
        
      },
      allowOutsideClick: () => false
    }).then((result) => {
      if(result) {
        console.log(result,"result")
      }
    })
  }

  const columns = [
    {
     name: "id",
     label: "User",
     options: {
      filter: true,
      sort: true,
      customBodyRenderLite:(value, dataIndex,updateValue) => { return data[dataIndex].user.name; }}
    },
    {
    name: "booking_id",
    label: "Booking Id",
    options: {
      filter: true,
      sort: false,
    }
    },
    {
    name: "provider",
    label: "Provider",
    options: {
      filter: true,
      sort: true,
      customBodyRenderLite:(value, dataIndex,updateValue) => {
          return data[dataIndex].provider == 2?'TBO':'HOTEL BEDS';
        }
      }
    },
    {
      name: "hotelName",
      label: "Hotel",
      options: {
        filter: true,
        sort: true,
        }
    },
    {
    name: "noOfRooms",
    label: "Rooms",
    options: {
      filter: true,
      sort: true,
      }
    },
    {
    name: "checkIn",
    label: "CheckIn",
    options: {
      filter: true,
      sort: true,
      }
    },
    {
    name: "checkOut",
    label: "CheckOut",
    options: {
      filter: true,
      sort: true,
      }
    },
    {
    name: "amount",
    label: "Amount",
    options: {
      filter: true,
      sort: false,
      customBodyRenderLite:(value, dataIndex,updateValue) => {
        var totalAmount = data[dataIndex].amount;
        return calc(totalAmount);
      }
      }
    },
    {
        name: "paymentStatus",
        label: "Payment",
        options: {
         filter: true,
         sort: false,
        // customBodyRenderLite:(value, dataIndex,updateValue) => {return "Success";}
        }
    },
    {
        name: "bookingStatus",
        label: "Booking Status",
        options: {
        filter: true,
        sort: false,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          return data[dataIndex].bookingStatus === 'CancellationInProgress' ? 'CANCELLED' : data[dataIndex].bookingStatus;
        }
        }
    },
    {
      name: "refund",
      label: "Refund",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          var totalAmount = data[dataIndex].refund;
          return calc(totalAmount);
        }
      }
    },
    {
      name: "booking_id",
      label: "Invoice",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          var bookingId = data[dataIndex].booking_id;
            return (
            <div onClick={(e)=>{window.location.replace(process.env.REACT_APP_BASEAPI_URL+'booking/invoice/'+bookingId)}} style={{cursor:"pointer"}}>
                <MaterialIcons color="secondary" icon="download" size={20} />
            </div>);
          }
        }
    },
    {
      name: "bookingStatus",
      label: "Action",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          if(data[dataIndex].bookingStatus == 'CancellationInProgress' || data[dataIndex].bookingStatus == 'CANCELLED'){
            //return "Refund"+data[dataIndex].booking_id;
            return <div>
              <Button title="Block"
                onClick={() => refund(data[dataIndex])}
                disabled={data[dataIndex].isRefunded == 1 ? "disabled" : ""}
              >
                  <MaterialIcons color={data[dataIndex].isRefunded == 1 ? "" : "secondary"} icon="paid" size={20}/>
              </Button>
            </div>

          } 
        }
  
        }
    },
  ];

  const options = {
    filterType: 'dropdown',
    selectableRowsOnClick:false,
    responsive: 'standard',
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    renderExpandableRow: (rowData, rowMeta) => {
      const bookingItienary = data[rowMeta['dataIndex']];
      if(bookingItienary.provider == 2){
          return (<TBOHotelDetail data={bookingItienary} />)
      }else{
          return (<HotelBedsDetails data={bookingItienary} />);
      }
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => console.log(curExpanded, allExpanded, rowsExpanded),
    onRowSelectionChange:(currentRowsSelected, allRowsSelected, rowsSelected) => {
       const abc = rowsSelected.map((r)=>{
         return data[r].id;
       })
        setSrow(abc);
    },
  };

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br}/>
       <h1>Hotels</h1>
       <Datatable title="Hotels Booking" data={data} columns={columns} options={options}/>
      </main>
    </div>
    
   
  );
}

export default HotelBooking;


// WEBPACK FOOTER //
// ./src/Pages/HotelBooking.js